import { Shape } from '@/services/shape';
import {
  addResourceIfNotExists,
  generateLayoutAst
} from '../utils/resource.utils';
import { VideoWatchfaceAttribute } from '@/services/shape/attributes/video-watchface';
import { getVideoSpriteAst } from './sprite';

export const getVideoWatchfaceAst = (resourceAst: Ast, shape: Shape) => {
  const { x = 0, y = 0 } = shape.attrs as VideoWatchfaceAttribute;

  // 在使用高级功能，即watchOS == 'android'时，
  // 在智能表下和非智能表需要区分处理

  const spriteAst = getVideoSpriteAst(resourceAst, shape);

  // 新增Sprite Ast，且不可复用
  // 注意这里需要确保自定义视频ast需要最后处理
  const spriteAst2 = addResourceIfNotExists(
    resourceAst,
    spriteAst,
    () => false
  );

  // 生成 layout ast
  const layoutAst: Ast = generateLayoutAst({
    ref: '@' + spriteAst2.attrsMap.name,
    x,
    y
  });

  layoutAst.attrsMap._id = shape.id;

  return layoutAst;
};
